import { render } from "./hrm-document-assign-modal.vue?vue&type=template&id=ccda701e&scoped=true"
import script from "./hrm-document-assign-modal.vue?vue&type=script&lang=js"
export * from "./hrm-document-assign-modal.vue?vue&type=script&lang=js"

import "./hrm-document-assign-modal.vue?vue&type=style&index=0&id=ccda701e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ccda701e"]])

export default __exports__